export const isInternetExplore = () => {
  const agent = navigator.userAgent.toLowerCase();
  return (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || (agent.indexOf('msie') !== -1);
};

export const isMobile = () => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
